import { render } from "./Todo.vue?vue&type=template&id=69711e16&scoped=true"
import script from "./Todo.vue?vue&type=script&lang=js"
export * from "./Todo.vue?vue&type=script&lang=js"

import "./Todo.vue?vue&type=style&index=0&id=69711e16&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69711e16"]])

export default __exports__